<template>
  <div class="grid grid-cols-6 gap-6">
    <div class="col-span-6">
      <FormInput
        id="linkedInCompanyName"
        type="text"
        :value="companyStore.linkedIn.linkedInName"
        :label="t('company.linkedInCompanyName')"
        :onInput="updateName"
        :rules="nameRules"
      />
    </div>
    <div class="col-span-6">
      <FormInput
        id="linkedInCompanyId"
        type="text"
        :value="companyStore.linkedIn.linkedInId"
        :label="t('company.linkedInCompanyId')"
        :onInput="updateId"
        :rules="{}"
      />
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { useCompanyStore } from '../../store/companyStore'
import { helpers, requiredIf } from '@vuelidate/validators'
import FormInput from '../FormInput.vue'

const companyStore = useCompanyStore()

const { t } = useI18n({
  inheritLocale: true,
  useScope: 'global',
})

const nameRules = {
  required: helpers.withMessage(
    t('validations.companyLinkedInName.required'),
    requiredIf(() => !!companyStore.linkedIn?.linkedInId),
  ),
}

const updateName = (newValue) => {
  companyStore.linkedIn.linkedInName = newValue
}

const updateId = (newValue) => {
  companyStore.linkedIn.linkedInId = newValue
}
</script>
